import React from 'react';
import './authScreen.css';

// Q17/Q19 keep the green page and wordmark; the card and controls use the
// same constitution tokens as the authenticated application.
export default function AuthScreenFrame({
  title,
  email,
  children,
}: {
  title: string;
  email?: string | null;
  children: React.ReactNode;
}) {
  return (
    <main className="wcf-auth-page">
      <section className="wcf-auth-card" aria-label={title}>
        <div className="wcf-auth-wordmark">WCF Planner</div>
        <h1 className="wcf-auth-title">{title}</h1>
        {email && <p className="wcf-auth-help wcf-auth-email">{email}</p>}
        {children}
      </section>
    </main>
  );
}
